<template>
  <div class="insights-dashboard" :style="navbarWithName ? { marginLeft: '160px' } : {}">
    <div class="header-card">
      <h1 class="dashboard-title">
        Insights Dashboard Platform
      </h1>
      <div class="dashboard-subtitle grey--text">
        Generate Report and Insights Analysis
      </div>
    </div>

    <div
      class="filters-container"
      style="display: flex; justify-content: space-between; align-items: center;"
    >
      <div style="display: flex; gap: 10px;">
        <div class="select-wrapper">
          <select
            v-model="selectedTopic"
            class="topic-periode-select"
            @change="updateSelectedTopicPeriode"
          >
            <option value="" disabled hidden>
              Select Topic
            </option>

            <option
              v-for="(item, index) in topicSentiment"
              :key="index"
              :value="item.SEQ_ID"
            >
              {{ item.TOPIC }}
            </option>
          </select>

          <v-icon class="chevron-icon" size="20">
            mdi-chevron-down
          </v-icon>
        </div>

        <div class="select-wrapper">
          <select
            v-model="selectedPeriode"
            class="topic-periode-select"
            @change="updateSelectedTopicPeriode"
          >
            <option value="" disabled hidden>
              Select Periode
            </option>
            <option
              v-for="(item, index) in periodeBerita"
              :key="index"
              :value="item.value"
            >
              {{ item.name }}
            </option>
          </select>
          <v-icon class="chevron-icon" size="20">
            mdi-chevron-down
          </v-icon>
        </div>
      </div>

      <button class="search-btn" @click="searchGeneratedNewsletters">
        <v-icon class="search-icon" color="white">
          mdi-magnify
        </v-icon>
        Search
      </button>
    </div>

    <div class="newsletters-section">
      <div class="section-header" @click="toggleNewsletters">
        <span class="chevron" :class="{ expanded: showNewsletters }">
          <v-icon>
            mdi-chevron-down
          </v-icon>
        </span>
        <span class="section-title">
          Generated Newsletters
        </span>
        <span class="newsletter-count">
          {{ newsletters.length }} newsletters
        </span>
      </div>

      <div v-if="showNewsletters" class="newsletters-list">
        <div
          v-for="newsletter in newsletters"
          :key="newsletter.id"
          class="newsletter-item"
        >
          <div class="newsletter-icon">
            <v-icon color="#007AFF">
              mdi-file-document-outline
            </v-icon>
          </div>
          <div class="newsletter-info">
            <h3 class="newsletter-title">
              {{ newsletter.title }}
            </h3>
            <p class="newsletter-meta">
              {{ newsletter.date.split(',')[0] }}, {{ newsletter.date.split(',')[1].split(' ')[1] }} • {{ newsletter.filesCount }} files included
            </p>
          </div>
          <div class="newsletter-actions">
            <v-icon class="mr-2" color="#000" @click="viewNewsletter(newsletter)">
              mdi-eye-outline
            </v-icon>
            <template v-if="downloadingId == newsletter.id">
              <v-progress-circular
                indeterminate
                class="mr-2"
                color="#000"
                size="20"
                width="2"
              ></v-progress-circular>
            </template>
            <template v-else>
              <v-icon class="mr-2" color="#000" @click="downloadNewsletter(newsletter)">
                mdi-download-outline
              </v-icon>
            </template>
            <v-icon
              class="mr-2"
              color="#FF3333"
              @click="selectedItemDelete = newsletter, deleteType = 'newsletter', dialogConfirmDelete = true"
            >
              mdi-delete-outline
            </v-icon>
          </div>
        </div>

        <div
          v-if="loadingNewsletters"
          class="d-flex justify-center"
          style="height: 80px; width: 100%;"
        >
          <v-progress-circular
            indeterminate
            color="primary"
            size="40"
            width="4"
          />
        </div>

        <p
          v-if="loadingNewsletters == false && newsletters.length == 0"
          class="ml-1 no-files-message"
          style="grid-column: 1 / -1; text-align: left; padding: 20px; color: #6B7280;"
        >
          No newsletter files were found for this category.
        </p>
      </div>
    </div>

    <div
      v-for="(insight, index) in listPageInsights"
      :key="insight.id"
      class="mt-6 insights-section"
      :class="{ 'mb-8': index == listPageInsights.length - 1 }"
    >
      <div class="section-header" @click="toggleInsights(insight)">
        <span class="chevron-insights" :class="{ expanded: insight.show }">
          <v-icon>mdi-chevron-down</v-icon>
        </span>
        <span class="section-title">
          {{ insight.title }}
        </span>
        <span class="file-count">
          {{ filterInsightsByType(insight.type).length }} files
        </span>
      </div>

      <div v-if="insight.show" class="insights-file-grid">
        <div
          v-for="file in filterInsightsByType(insight.type)"
          :key="file.id"
          class="file-card"
          @click="viewNewsletter(file)"
        >
          <div class="file-card-actions" @click.stop>
            <v-checkbox
              class="file-card-checkbox"
              dense
              hide-details
              :input-value="isFileSelected(file)"
              @click.stop="toggleFileSelection(file)"
            ></v-checkbox>
            <div class="file-card-actions-divider"></div>
            <v-btn
              class="file-card-delete"
              icon
              small
              @click.stop="selectedItemDelete = file, deleteType = 'insight', dialogConfirmDelete = true"
            >
              <v-icon color="#FF3333" size="20">
                mdi-delete-outline
              </v-icon>
            </v-btn>
          </div>

          <div class="file-icon-wrapper">
            <v-icon color="#9CA3AF" size="48">
              mdi-file-document-outline
            </v-icon>
          </div>
          <p class="file-name">
            {{ file.nameFile }}
          </p>
        </div>

        <div
          v-if="loadingInsights"
          class="d-flex justify-center"
          style="height: 80px; width: 100%; grid-column: 1 / -1;"
        >
          <v-progress-circular
            indeterminate
            color="primary"
            size="40"
            width="4"
          />
        </div>

        <p
          v-if="loadingInsights == false && filterInsightsByType(insight.type).length == 0"
          class="no-files-message"
          style="grid-column: 1 / -1; text-align: left; padding: 20px; color: #6B7280;"
        >
          No insight files were found for this category.
        </p>
      </div>
    </div>

    <v-dialog v-model="dialogViewPDF" max-width="90%" @keydown.esc="dialogViewPDF = false">
      <v-card
        class="pa-4"
        style="width: 100%; height: 90vh; display: flex; flex-direction: column;"
        rounded="xl"
        elevation="10"
      >
        <div class="d-flex justify-space-between align-center mb-2">
          <h3 class="text-h6 ml-1 mb-0">
            {{ selectedTitlePDF }}
          </h3>
          <v-btn icon @click="dialogViewPDF = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>

        <iframe
          v-if="selectedPDF"
          :src="selectedPDF"
          style="flex: 1; width: 100%; border: none; border-radius: 8px;"
        ></iframe>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogInputTitle" persistent max-width="440">
      <v-card class="pa-4" rounded="xl" elevation="10">
        <v-btn
          class="confirm-reset ma-0 pa-0"
          style="position: absolute; top: 8px; right: 8px;"
          color="#aaa"
          icon
          small
          @click="dialogInputTitle = false"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-card-title class="justify-center text-center">
          <span class="text-h6 font-weight-medium">
            Generated Newsletter Title
          </span>
        </v-card-title>

        <v-card-text>
          <p class="text-body-2 text-grey-darken-1 text-center mb-4">
            Please enter a title for your generated newsletter below.
          </p>

          <v-text-field
            v-model="newsletterTitle"
            label="Enter title..."
            class="rounded-lg"
            color="var(--color-theme-secondary)"
            variant="outlined"
            hide-details="auto"
            :error="newsletterTitleError"
            :error-messages="newsletterTitleError ? 'Newsletter title is required' : ''"
            @input="clearNewsletterTitleError"
            @keyup.enter="handleGeneratedNewsletter"
          ></v-text-field>
        </v-card-text>

        <v-divider class="my-2"></v-divider>

        <v-card-actions class="justify-end">
          <v-btn
            color="grey-darken-1"
            text
            @click="dialogInputTitle = false"
          >
            Cancel
          </v-btn>

          <v-btn
            class="white--text"
            color="var(--color-theme-secondary)"
            variant="elevated"
            rounded="lg"
            @click="handleGeneratedNewsletter"
          >
            <template v-if="!loadingGeneratedNewsletter">
              Save
            </template>

            <template v-else>
              <v-progress-circular
                indeterminate
                color="white"
                size="20"
                width="3"
              />
            </template>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogConfirmDelete" width="330px">
      <v-card class="text-center align-center justify-center rounded-lg pa-6" width="330px">
        <v-avatar class="color-confirm-delete-newsletter my-4" size="62">
          <v-icon class="white--text" x-large>
            mdi-trash-can-outline
          </v-icon>
        </v-avatar>
        <div class="text-center text-h6 font-weight-medium">
          Confirm Deletion
        </div>
        <v-card-text class="mt-2">
          Are you sure you want to delete this
          {{ deleteType == 'newsletter' ? 'generated newsletter' : 'insight file' }}?
        </v-card-text>
        <v-divider class="mt-4"></v-divider>
        <v-card-actions class="align-center justify-center">
          <v-btn
            class="my-3"
            color="red"
            width="90px"
            rounded
            outlined
            dark
            @click="dialogConfirmDelete = false"
          >
            Cancel
          </v-btn>
          <v-btn
            class="my-3 btn-color-confirm-delete-newsletter"
            width="90px"
            rounded
            dark
            @click="deleteConfirmed"
          >
            OK
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialogSuccessGenerateNewsletter"
      persistent
      max-width="330px"
    >
      <v-card
        class="text-center align-center justify-center rounded-lg pa-6"
        width="330px"
      >
        <v-avatar
          color="var(--color-theme)"
          style="border: 2px solid var(--color-theme);"
          size="80"
        >
          <v-icon class="white--text" size="80">
            mdi-check
          </v-icon>
        </v-avatar>

        <h1 class="mt-2 text-center text-h6 align-center justify-center" style="text-wrap: wrap">
          Newsletter successfully generated
        </h1>

        <v-divider class="mt-4"></v-divider>

        <v-card-actions class="align-center justify-center">
          <v-btn
            color="var(--color-theme)"
            style="borderRadius: 8px"
            size="large"
            height="40px"
            width="120px"
            dark
            @click="dialogSuccessGenerateNewsletter = false"
          >
            OK
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <div class="floating-action-bar" :class="{ 'active': selectedFiles.length > 0 }">
      <div class="selection-status">
        <template v-if="selectedFiles.length > 0">
          {{ selectedFiles.length }} file{{ selectedFiles.length > 1 ? 's' : '' }} selected
        </template>
        <template v-else>
          No files selected
        </template>
      </div>

      <v-btn
        class="generate-btn"
        color="primary"
        :disabled="selectedFiles.length == 0"
        @click="dialogInputTitle = true"
      >
        <v-icon left>
          mdi-file-document-outline
        </v-icon>
        Generate Newsletter
      </v-btn>
    </div>

    <div>
      <Notification ref="alert"></Notification>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { decryptionData, generateFilterDate, trackEvent } from '@/components/utils/utils.js';
import { mapGetters } from 'vuex';
import runtimeConfig from '../configRuntime.js';
import Notification from '@/components/Notification';
const authToken = localStorage.getItem("token_app");

export default {
  components: {
    Notification: Notification,
  },
  data: function() {
    return {
      showNewsletters: true,
      loadingNewsletters: false,
      newsletters: [],
      selectedTitlePDF: "",
      dialogViewPDF: false,
      selectedPDF: "",
      downloadingId: null,
      dialogConfirmDelete: false,
      selectedItemDelete: null,
      deleteType: "",
      listPageInsights: [
        { id: 1, title: "Dashboard Page Insights", type: "newsletter dashboard", show: true },
        { id: 2, title: "Trending Topic Insights", type: "newsletter trendingtopic", show: false },
        { id: 3, title: "Media Share Insights", type: "newsletter media share", show: false },
        { id: 4, title: "Insights from Contents", type: "newsletter content analysis", show: false },
      ],
      loadingInsights: false,
      insightsFiles: [],
      selectedFiles: [],
      dialogInputTitle: false,
      newsletterTitle: "",
      newsletterTitleError: false,
      loadingGeneratedNewsletter: false,
      dialogSuccessGenerateNewsletter: false,
      selectedTopic: "",
      selectedPeriode: "",
      topicSentiment: [],
      periodeBerita: [
        { name: 'Today', value: 'Today' },
        { name: 'From Yesterday', value: 'From Yesterday' },
        { name: 'This Week', value: 'This Week' },
        { name: 'From Previous Week', value: 'Previous Week' },
        { name: 'This Month', value: 'This Month' },
        { name: 'Previous Month', value: 'Previous Month' }
      ],
      token: authToken,
    }
  },
  computed: {
    ...mapGetters(['navbarWithName']),
  },
  mounted() {
    this.getNewsletters();
    this.getInsights();
    this.loadTopic();
  },
  methods: {
    async searchGeneratedNewsletters() {
      const [newslettersResponse, insightsResponse] = await Promise.all([
        axios.get("newsletters", {
          params: {
            topic: this.selectedTopic,
            periode: this.selectedPeriode,
          },
          headers: {
            "auth-token": this.token,
          },
        }),
        axios.get("insights", {
          params: {
            topic: this.selectedTopic,
            periode: this.selectedPeriode,
          },
          headers: {
            "auth-token": this.token,
          },
        }),
      ]);

      trackEvent("newsletter", { topic: this.selectedTopic, periode: this.selectedPeriode });

      this.newsletters = newslettersResponse.data;
      this.insightsFiles = insightsResponse.data;
    },
    isFileSelected(file) {
      return this.selectedFiles.some(f => f.id == file.id);
    },
    toggleFileSelection(file) {
      const index = this.selectedFiles.findIndex(f => f.id == file.id);

      if (index == -1) {
        const existingFileIndex = this.selectedFiles.findIndex(f => f.type == file.type);

        if (existingFileIndex != -1) {
          this.selectedFiles.splice(existingFileIndex, 1, file);
        } else {
          this.selectedFiles.push(file);
        }
      } else {
        this.selectedFiles.splice(index, 1);
      }
    },
    async handleGeneratedNewsletter() {
      trackEvent("newsletter-generate", { title: this.newsletterTitle });

      if (this.loadingGeneratedNewsletter) return;

      try {
        this.loadingGeneratedNewsletter = true;

        if (!this.newsletterTitle || this.newsletterTitle.trim() == "") {
          this.newsletterTitleError = true;
          return;
        }

        const sortOrder = [
          'newsletter dashboard',
          'newsletter trendingtopic',
          'newsletter media share',
          'newsletter content analysis',
        ];

        const sortedFiles = [...this.selectedFiles].sort((a, b) => {
          const indexA = sortOrder.indexOf(a.type);
          const indexB = sortOrder.indexOf(b.type);
          return (indexA == -1 ? Infinity : indexA) - (indexB == -1 ? Infinity : indexB);
        });

        const pdfBuffers = await Promise.all(
          sortedFiles.map(async (file) => {
            if (file.filePath) {
              try {
                const response = await fetch(`${runtimeConfig.VUE_APP_API_SOCKET}${file.filePath}`);
                const arrayBuffer = await response.arrayBuffer();
                return new Uint8Array(arrayBuffer);
              } catch (error) {
                console.error('Error fetching PDF from filePath:', error);
              }
            }
          })
        );

        const { PDFDocument } = await import('pdf-lib');
        const mergedPdf = await PDFDocument.create();

        for (const pdfBuffer of pdfBuffers) {
          const pdfDoc = await PDFDocument.load(pdfBuffer);
          const pages = await mergedPdf.copyPages(pdfDoc, pdfDoc.getPageIndices());
          pages.forEach(page => mergedPdf.addPage(page));
        }

        const mergedPdfBytes = await mergedPdf.save();

        const dateStr = new Date().toLocaleString("en-US", {
          month: "short",
          day: "2-digit",
          year: "numeric",
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit",
          hour12: true,
        });

        const newsletterTopics = [...new Set(this.selectedFiles.map(f => f.topic))];
        const newsletterPeriodes = [...new Set(this.selectedFiles.map(f => f.periode))];

        const formData = new FormData();
        formData.append('file', new Blob([mergedPdfBytes], { type: 'application/pdf' }), `${this.newsletterTitle}.pdf`);
        formData.append('title', this.newsletterTitle);
        formData.append('nameFile', `${this.newsletterTitle}.pdf`);
        formData.append('date', dateStr);
        formData.append('filesCount', this.selectedFiles.length.toString());
        formData.append('topics', JSON.stringify(newsletterTopics));
        formData.append('periodes', JSON.stringify(newsletterPeriodes));

        const responseGeneratedNewsletter = await axios.post(
          "newsletters/generated",
          formData,
          {
            headers: {
              "auth-token": this.token,
              "Content-Type": "multipart/form-data",
            },
          }
        );

        this.loadingNewsletters = true;
        this.newsletters = [];

        await new Promise(resolve => setTimeout(resolve, 5000));

        try {
          await this.getNewsletters();
        } catch (error) {
          await new Promise(resolve => setTimeout(resolve, 5000));
          await this.getNewsletters();
        }

        this.dialogInputTitle = false;
        this.newsletterTitle = "";
        this.selectedFiles = [];
        this.loadingGeneratedNewsletter = false;

        if (responseGeneratedNewsletter.status == 200) {
          this.dialogSuccessGenerateNewsletter = true;
        }
      } catch (error) {
        this.loadingGeneratedNewsletter = false;
        console.error('Error generating newsletter:', error);
      }
    },
    clearNewsletterTitleError() {
      if (this.newsletterTitleError) {
        this.newsletterTitleError = false;
      }
    },
    async getNewsletters() {
      if (this.newsletters.length == 0) {
        this.loadingNewsletters = true;
      }

      try {
        const response = await this.retryGet(() =>
          axios.get("newsletters", {
            headers: { 'auth-token': this.token },
          })
        );

        this.newsletters = response.data;
        this.loadingNewsletters = false;
      } catch (err) {
        this.loadingNewsletters = false;
        console.error("Gagal mengambil data newsletters:", err);
      }
    },
    toggleNewsletters() {
      this.showNewsletters = !this.showNewsletters;
    },
    viewNewsletter(newsletter) {
      trackEvent("newsletter-view", { id: newsletter.id, filename: newsletter.nameFile });

      this.selectedTitlePDF = newsletter.nameFile;

      if (this.selectedPDF && typeof this.selectedPDF == 'string' && this.selectedPDF.startsWith('blob:')) {
        try {
          URL.revokeObjectURL(this.selectedPDF);
        } catch (e) {
          console.warn('Failed to revoke object URL:', e);
        }
      }

      if (newsletter.filePath && typeof newsletter.filePath == 'string') {
        this.selectedPDF = `${runtimeConfig.VUE_APP_API_SOCKET}${newsletter.filePath}`;
        this.dialogViewPDF = true;
        return;
      }
    },
    async downloadNewsletter(newsletter) {
      trackEvent("newsletter-download", { id: newsletter.id, filename: newsletter.nameFile });

      try {
        this.downloadingId = newsletter.id;

        const response = await fetch(`${runtimeConfig.VUE_APP_API_SOCKET}${newsletter.filePath}`);

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const blob = await response.blob();

        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = newsletter.nameFile;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        setTimeout(() => URL.revokeObjectURL(link.href), 1000);
      } catch (err) {
        console.error("Gagal download PDF:", err);
      } finally {
        this.downloadingId = null;
      }
    },
    async deleteConfirmed() {
      trackEvent("newsletter-delete", { id: this.selectedItemDelete.id });

      try {
        const endpoint = this.deleteType == 'newsletter'
          ? `newsletters/${this.selectedItemDelete.id}`
          : `insights/${this.selectedItemDelete.id}`;

        const response = await axios.delete(endpoint, {
          headers: { 'auth-token': this.token },
        });

        if (response.data.status == 200) {
          if (this.deleteType == 'newsletter') {
            this.newsletters = [];
            this.getNewsletters();
          } else {
            this.insightsFiles = [];
            this.getInsights();
          }
          this.dialogConfirmDelete = false;
          this.selectedItemDelete = null;
          this.deleteType = "";
        }
      } catch (error) {
        console.error('Error saat menghapus:', error);
      }
    },
    async retryGet(requestFn, { maxRetries = Infinity, delayMs = 2000 } = {}) {
      let attempt = 0;
      while (attempt < maxRetries) {
        try {
          const result = await requestFn();
          return result;
        } catch (err) {
          attempt++;
          const isServerDown = !err.response || err.code == 'ECONNREFUSED' || err.response?.status >= 500;

          if (!isServerDown || attempt >= maxRetries) {
            throw err;
          }

          await new Promise(resolve => setTimeout(resolve, delayMs));
        }
      }
    },
    toggleInsights(insight) {
      insight.show = !insight.show;
    },
    async getInsights() {
      if (this.insightsFiles.length == 0) {
        this.loadingInsights = true;
      }

      try {
        const response = await this.retryGet(() =>
          axios.get("insights", {
            headers: { 'auth-token': this.token },
          })
        );

        this.insightsFiles = response.data;
        this.loadingInsights = false;
      } catch (err) {
        this.loadingInsights = false;
        console.error("Gagal mengambil data insights file:", err);
      }
    },
    filterInsightsByType(insightType) {
      if (!this.insightsFiles || this.insightsFiles.length == 0) {
        return [];
      }

      const normalizedType = insightType.toLowerCase().trim();

      return this.insightsFiles.filter(file => {
        return file.type && file.type.toLowerCase().trim() == normalizedType;
      });
    },
    async loadTopic() {
      axios.get("keyword_select",
        { headers: { 'auth-token': localStorage.getItem('token_app') } },
        { dataType: 'json' }
      )
      .then((response) => {
        const dataDec = decryptionData(response.data.token);
        const data = dataDec.keyword;

        this.topicSentiment = [];

        for (let i = 0; i < data.length; i++) {
          this.topicSentiment.push(data[i]);
        }
      })
      .catch((e) => {
        if (e.response) {
          const { status } = e.response;

          switch (status) {
            case 404:
              this.$refs.alert.error_login(404);
              break;
            case 403:
              this.$refs.alert.error_login(403);
              break;
            default:
              console.log("some other error");
              break;
          }
        } else {
          this.alert = true;
          setTimeout(() => {
            this.alert = false;
          }, 10000);
          this.message = "API Keyword Select Refused To Connect";
          this.colorAlert = "red";
        }
      });
    },
    updateSelectedTopicPeriode() {
      let isShowDate = this.$store.is_show_date_glob;
      let startDate = "";
      let endDate = "";
      let periode = this.selectedPeriode.toUpperCase().replace(/ /g, '_');
      let dateGenerate = generateFilterDate(periode);
      startDate = dateGenerate.start_date;
      endDate = dateGenerate.end_date;

      let jenisParameter = "";
      if (this.selectedPeriode == "Custom") {
        jenisParameter = "custom";
      } else {
        jenisParameter = "periode";
      }

      this.$store.commit("addParameter", {
        jenis_parameter_glob: jenisParameter,
        topic_glob: this.selectedTopic,
        topic_glob2: "All",
        selectedPeriode_glob: this.selectedPeriode,
        date_start_glob: startDate,
        date_end_glob: endDate,
        is_show_date_glob: isShowDate
      });
    },
  }
}
</script>

<style scoped>
.floating-action-bar {
  background-color: white;
  border-top: 1px solid #e5e7eb;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.05);
  padding: 15px 30px;
}

.selection-status {
  color: #374151;
  font-size: 17px;
  margin-left: 75px;
}

.generate-btn {
  font-size: 15px !important;
  font-weight: 600 !important;
  text-transform: none !important;
  height: 42px !important;
  padding: 0 20px !important;
}

.insights-dashboard {
  font-family: Segoe UI;
  background-color: #fff;
  min-height: 100vh;
  max-width: 1200px;
  width: 95%;
  border-radius: 12px;
  margin: 0 auto;
  padding: 0px;
}

@media (min-width: 1370px) and (max-width: 1599px) {
  .insights-dashboard {
    width: 95%;
    max-width: 1350px;
  }
}

@media (min-width: 1600px) and (max-width: 1799px) {
  .insights-dashboard {
    width: 95%;
    max-width: 1540px;
  }
}

@media (min-width: 1800px) and (max-width: 1999px) {
  .insights-dashboard {
    width: 95%;
    max-width: 1650px;
  }
}

.header-card {
  background-color: white;
  border-radius: 12px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
  margin-bottom: 20px;
  padding: 24px 30px;
}

.dashboard-title {
  font-size: 28px;
  font-weight: 600;
  margin: 0;
  color: #1a1a1a;
}

.dashboard-subtitle {
  font-size: 17px;
}

@media (min-width: 1369px) and (max-width: 1599px) {
  .dashboard-subtitle {
    font-size: 18px;
  }

  .search-btn {
    font-size: 18px !important;
  }

  .search-icon {
    font-size: 25px !important;
  }

  .chevron .v-icon {
    font-size: 34px !important;
  }

  .section-title {
    font-size: 19px !important;
  }

  .newsletter-count {
    font-size: 19px !important;
  }

  .newsletter-icon {
    height: 51px !important;
    width: 51px !important;
  }

  .newsletter-icon .v-icon {
    font-size: 27px !important;
  }

  .newsletter-title {
    font-size: 17px !important;
  }

  .newsletter-meta {
    font-size: 16px !important;
  }

  .chevron-insights .v-icon {
    font-size: 34px !important;
  }

  .file-count {
    font-size: 19px !important;
  }

  .file-name {
    font-size: 16.2px !important;
  }

  .no-files-message {
    font-size: 18px !important;
  }

  .selection-status {
    font-size: 18px !important;
  }

  .generate-btn {
    height: 45px !important;
    font-size: 17px !important;
  }

  .generate-btn .v-icon {
    font-size: 19px !important;
  }
}

@media (min-width: 1600px) {
  .dashboard-subtitle {
    font-size: 19px;
  }

  .search-btn {
    font-size: 19px !important;
  }

  .search-icon {
    font-size: 27px !important;
  }

  .chevron .v-icon {
    font-size: 38px !important;
  }

  .section-title {
    font-size: 20px !important;
  }

  .newsletter-count {
    font-size: 20px !important;
  }

  .newsletter-icon {
    height: 52px !important;
    width: 52px !important;
  }

  .newsletter-icon .v-icon {
    font-size: 28px !important;
  }

  .newsletter-title {
    font-size: 19px !important;
  }

  .newsletter-meta {
    font-size: 17px !important;
  }

  .newsletter-actions .v-icon {
    font-size: 28px !important;
  }

  .chevron-insights .v-icon {
    font-size: 38px !important;
  }

  .file-count {
    font-size: 20px !important;
  }

  .file-card {
    height: 200px !important;
    width: 200px !important;
  }

  .file-name {
    font-size: 17px !important;
  }

  .no-files-message {
    font-size: 18.5px !important;
  }

  .selection-status {
    font-size: 19px !important;
  }

  .generate-btn .v-icon {
    font-size: 19px !important;
  }

  .generate-btn {
    font-size: 18px !important;
  }
}

@media (min-width: 2000px) {
  .insights-dashboard {
    width: 95%;
    max-width: 1850px;
  }

  .dashboard-subtitle {
    font-size: 20px;
  }

  .search-btn {
    font-size: 20px !important;
  }

  .search-icon {
    font-size: 29px !important;
  }

  .chevron .v-icon {
    font-size: 40px !important;
  }

  .section-title {
    font-size: 21px !important;
  }

  .newsletter-count {
    font-size: 21px !important;
  }

  .newsletter-icon {
    height: 56px !important;
    width: 56px !important;
  }

  .newsletter-icon .v-icon {
    font-size: 32px !important;
  }

  .newsletter-title {
    font-size: 21px !important;
  }

  .newsletter-meta {
    font-size: 18px !important;
  }

  .newsletter-actions .v-icon {
    font-size: 32px !important;
  }

  .chevron-insights .v-icon {
    font-size: 42px !important;
  }

  .file-count {
    font-size: 21px !important;
  }

  .file-card {
    height: 220px !important;
    width: 220px !important;
  }

  .file-name {
    font-size: 18px !important;
  }

  .no-files-message {
    font-size: 19px !important;
  }

  .selection-status {
    font-size: 20px !important;
  }

  .generate-btn {
    height: 50px !important;
    font-size: 20px !important;
  }

  .generate-btn .v-icon {
    font-size: 21px !important;
  }
}

.filters-container {
  display: flex;
  align-items: center;
  gap: 15px;
}

.select-wrapper {
  position: relative;
  max-width: 250px;
  flex: 1;
}

.topic-periode-select {
  background-color: white;
  cursor: pointer;
  outline: none;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  font-size: 14px;
  height: 47px;
  width: 100%;
  padding: 12px 40px 12px 16px;
  transition: border-color 0.2s, box-shadow 0.2s;
}

.topic-periode-select:focus {
  border-color: #0471A5;
  box-shadow: 0 0 0 2px rgba(4, 113, 165, 0.15);
}

.chevron-icon {
  position: absolute;
  pointer-events: none;
  color: #666;
  transition: color 0.2s;
  transform: translateY(-50%);
  top: 50%;
  right: 14px;
}

.search-btn {
  background-color: #000;
  color: white;
  cursor: pointer;
  display: flex;
  align-items: center;
  border: none;
  border-radius: 8px;
  font-size: 17px;
  font-weight: 500;
  gap: 8px;
  padding: 12px 24px;
  transition: background-color 0.2s;
}

.search-icon {
  font-size: 23px;
}

.newsletters-section {
  background-image: linear-gradient(to right, rgba(230, 240, 255, 0.6), #FFFFFF);
  box-shadow: none;
  border: 1px solid #e8e8e8;
  border-radius: 8px;
  margin-top: 24px;
  padding: 0;
}

.section-header {
  display: flex;
  align-items: center;
  background-color: transparent;
  border-bottom: none;
  cursor: pointer;
  user-select: none;
  gap: 12px;
  margin-bottom: 0;
  padding: 20px 20px;
}

.chevron {
  font-size: 10px;
  transition: transform 0.3s ease;
}

.chevron .v-icon {
  color: #007AFF !important;
  font-size: 32px;
}

.chevron-insights .v-icon {
  color: #000 !important;
  font-size: 32px !important;
}

.chevron.expanded {
  transform: rotate(0deg);
}

.chevron:not(.expanded) {
  transform: rotate(-90deg);
}

.section-title {
  font-size: 18px;
  font-weight: 600;
  color: #000;
}

.newsletter-count {
  font-size: 17px;
  color: #6C757D;
  margin-left: auto;
}

.newsletters-list {
  display: flex;
  flex-direction: column;
  gap: 0px;
}

.newsletter-item {
  display: flex;
  align-items: center;
  background-color: #fafafa;
  border: 1px solid #f0f0f0;
  border-radius: 10px;
  gap: 16px;
  padding: 20px;
  transition: all 0.2s;
}

.newsletter-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  height: 48px;
  width: 48px;
  border-radius: 8px;
  background-color: rgba(230, 240, 255);
}

.newsletter-info {
  flex: 1;
}

.newsletter-title {
  color: #1a1a1a;
  font-size: 16px;
  font-weight: 600;
  margin: 0 0 6px 0;
}

.newsletter-meta {
  color: #666;
  font-size: 14px;
  margin: 0;
}

.newsletter-actions {
  display: flex;
  align-items: center;
  gap: 12px;
}

.insights-section {
  background-color: #FFFFFF;
  box-shadow: none;
  border: 1px solid #e8e8e8;
  border-radius: 8px;
  margin-top: 2rem;
  padding: 0;
}

.file-count {
  font-size: 17px;
  color: #6B7280;
  margin-left: auto;
}

.insights-file-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
  gap: 1rem;
  padding: 20px;
}

.file-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  background: #FFFFFF;
  border: 1px solid #E5E7EB;
  border-radius: 0.5rem;
  cursor: pointer;
  transition: all 0.2s ease;
  padding: 1.5rem 1rem;
  padding-top: 20px;
}

.file-card:hover {
  border-color: #D1D5DB;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.file-icon-wrapper {
  margin-bottom: 0.75rem;
}

.file-name {
  color: #374151;
  text-align: center;
  word-break: break-word;
  font-size: 16px;
  line-height: 1.4;
  margin: 0;
}

.file-card-actions {
  position: absolute;
  top: 0px;
  right: 0px;
  width: 28px;
  background: #FFFFFF;
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow: hidden;
  border: 1px solid #D1D5DB;
  border-radius: 6px;
}

.file-card-actions-divider {
  background-color: #D1D5DB;
  height: 1px;
  width: 100%;
}

.file-card-checkbox {
  margin: 0 !important;
  padding: 4px 1px !important;
}

.file-card-checkbox .v-input--selection-controls__input {
  height: 20px !important;
  width: 20px !important;
  margin: 0 !important;
}

.file-card-delete {
  height: auto !important;
  width: 100% !important;
  border-radius: 0 !important;
  margin: 0 !important;
  padding: 2px 0 !important;
}

.v-avatar.color-confirm-delete-newsletter {
  box-shadow: 0 5px 15px rgba(255, 0, 0, 0.4);
  background-image: linear-gradient(
    to bottom,
    #ff8b8b,
    #ff8284,
    #ff787d,
    #ff6e76,
    #ff646f,
    #ff5c6a,
    #ff5464,
    #ff4b5f,
    #ff4359,
    #ff3b54,
    #ff314e,
    #ff2648
  );
}

.btn-color-confirm-delete-newsletter {
  box-shadow: 0 5px 15px rgba(255, 0, 0, 0.4);
  background-image: linear-gradient(
    to bottom,
    #ff8b8b,
    #ff8284,
    #ff787d,
    #ff6e76,
    #ff646f,
    #ff5c6a,
    #ff5464,
    #ff4b5f,
    #ff4359,
    #ff3b54,
    #ff314e,
    #ff2648
  );
}
</style>